import React, { useMemo, useState } from "react";
import NumberedPagination from "../../pagination/NumberedPagination";
import QuestionItem from "./QuestionItem";

const QuestionList = ({ questions }) => {
  const pageSize = 10;

  const [currentPage, setCurrentPage] = useState(1);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return questions?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, questions]);

  const len = questions?.length;

  return (
    <div className="flex flex-col gap-6">
      <div>
        {questions?.length === 0 ? (
          <div className="row-span-full text-center">
            <span className="text-center">No Question found</span>
          </div>
        ) : (
          currentTableData?.map((question, index) => (
            <QuestionItem
              key={question?._id}
              index={(currentPage - 1) * pageSize + index}
              question={question}
            />
          ))
        )}
      </div>
      <NumberedPagination
        currentPage={currentPage}
        totalCount={len}
        pageSize={pageSize}
        onPageChange={(page) => setCurrentPage(page)}
      />
      <p className="sm:self-end self-center">Total questions: {len}</p>
    </div>
  );
};

export default QuestionList;
